import React, { useContext } from "react";
import { RegisterFormContext } from "../../Context/RegisterFormContext";
import { MyContext } from "../../Context/MyContext";

export default function DisplayTotal() {

  const {formData} = useContext(RegisterFormContext)

    const { currency } =
      useContext(MyContext);
      
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: '5px',
        justifyContent: 'center',
        textAlign: 'center',
        marginBottom: "1rem",
        paddingTop: "1rem",
        background: '#fff',
        padding: '1rem 2rem',
        background: '#a81e1e',
        borderTopLeftRadius: '2rem',
        borderBottomLeftRadius: '2rem',
        color: '#fff',
        margin: "0px auto",
        maxWidth: '800px',
        marginBottom: '2rem',
        position: 'fixed',
        right: '0',
        top: '100px',
        boxShadow: '0px 2px 15px rgba(0,0,0,0.5)',
        zIndex: 99999
      }}
    >
      <div>Total</div>
      <div style={{fontSize: 'clamp(1.1rem, 5vw, 1.5rem', fontWeight: 'bold'}}>{currency}{" "}{formData.totalCost > formData.totalCostAfterGuidanceAndSupport ? formData.totalCost : formData.totalCostAfterGuidanceAndSupport }</div>
    </div>
  );
}
